import { render } from "./MenuPay.vue?vue&type=template&id=6ddddace&scoped=true"
import script from "./MenuPay.vue?vue&type=script&lang=js"
export * from "./MenuPay.vue?vue&type=script&lang=js"

import "./MenuPay.vue?vue&type=style&index=0&id=6ddddace&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddddace"]])

export default __exports__